var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.889 0H3.11A3.12 3.12 0 000 3.111V24.89A3.12 3.12 0 003.111 28H24.89A3.12 3.12 0 0028 24.889V3.11A3.12 3.12 0 0024.889 0zM10.11 13.222c0 1.245-1.089 2.334-2.333 2.334H6.222v3.11H3.89V9.334h3.889c1.244 0 2.333 1.09 2.333 2.334v1.555zm7.778 3.111c0 1.245-1.089 2.334-2.333 2.334h-3.89V9.333h3.89c1.244 0 2.333 1.09 2.333 2.334v4.666zm6.222-4.666h-2.333v1.555h2.333v2.334h-2.333v3.11h-2.334V9.334h4.667v2.334zm-10.111 0h1.556v4.666H14v-4.666zm-7.778 0h1.556v1.555H6.222v-1.555z",
    fill: "currentColor"
  })));
}

export default SvgPdf;